import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ViewVideo() {
  const location = useLocation();
  const navigate = useNavigate();
  const video = location.state;

  if (!video) {
    return (
      <div className="text-center py-5">
        <h4>No video selected.</h4>
        <button className="btn btn-danger mt-3" onClick={() => navigate("/game")}>
          Back to Game
        </button>
      </div>
    );
  }

  return (
    <div className="container text-center py-4">
      <div className="ratio ratio-16x9 mb-4">
        <iframe
          src={`https://www.youtube.com/embed/${video.youtubeId}`}
          title={video.title}
          allowFullScreen
        ></iframe>
      </div>

      <h4 className="text-danger fw-bold mb-2">Like & Watch</h4>
      <p className="text-muted mb-4">Earn profit when you like and watch videos</p>

      <button
        className="btn btn-danger rounded-pill px-4"
        onClick={() => navigate("/packageinfo")}
      >
        View Now
      </button>
    </div>
  );
}
